import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import Cookies from 'js-cookie'
import Quasar from 'quasar/src/vue-plugin.js';
import quasarUserOptions from './quasar-user-options'

// Get CSRF token from cookies
const csrftoken = Cookies.get('csrftoken');

if (csrftoken) {
  axios.defaults.headers.common['X-CSRFToken'] = csrftoken;
} else {
  console.error("CSRF token not found");
}

// Ensure credentials are sent with each request
axios.defaults.withCredentials = true;

// Set up a default axios instance
axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;

const app = createApp(App).use(Quasar, quasarUserOptions);

app.use(router);

app.mount('#app');
